var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { setPassiveTouchGestures } from '@polymer/polymer/lib/utils/settings.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { installMediaQueryWatcher } from 'pwa-helpers/media-query.js';
import { installOfflineWatcher } from 'pwa-helpers/network.js';
import { installRouter } from 'pwa-helpers/router.js';
import { updateMetadata } from 'pwa-helpers/metadata.js';
import { store } from '../store.js';
import { navigate, updateOffline, updateDrawerState, firebaseInitialize, loadJobTypes, getJobById, getJob } from '../actions/app.js';
import '@polymer/app-layout/app-header-layout/app-header-layout.js';
import '@polymer/app-layout/app-drawer/app-drawer.js';
import '@polymer/app-layout/app-header/app-header.js';
import '@polymer/app-layout/app-scroll-effects/effects/waterfall.js';
import '@polymer/app-layout/app-toolbar/app-toolbar.js';
import '@polymer/paper-progress/paper-progress';
import { menuIcon } from './my-icons.js';
import './snack-bar.js';
import './my-account';
if (typeof window !== 'undefined') {
    window.getJobById = getJobById;
    window.getJob = getJob;
}
let BlueWater = class BlueWater extends connect(store)(LitElement) {
    static get styles() {
        return [
            css `
        :host {
          display: block;

          --app-drawer-width: 256px;

          --app-primary-color: #4fb2ec;
          --app-secondary-color: #3b7fc7;
          --app-dark-text-color: var(--app-secondary-color);
          --app-light-text-color: white;
          --app-neg-text-color: #d42611;
          --app-section-even-color: #f7f7f7;
          --app-section-odd-color: white;

          --app-disabled-color: #a8a8a8;

          --app-header-background-color: var(white) !important;
          --app-header-text-color: var(--app-dark-text-color);
          --app-header-selected-color: var(--app-secondary-color);

          --app-drawer-background-color: var(--app-secondary-color);
          --app-drawer-text-color: var(--app-light-text-color);
          --app-drawer-selected-color: #78909c;

          --paper-tab-ink: var(app-primary-color);
          --paper-ripple: var(app-primary-color);
          --paper-tabs-selection-bar-color: var(app-primary-color);
        }



        app-header {
          position: fixed;
          display: inline-block;
          box-sizing: border-box;
          top: 1%;
          background-color: var(--app-header-background-color);
          color: var(--app-header-text-color);
          background-color: white;
          border-bottom: 1px solid #eee;
          width: 100%;
          text-align: center;
        }

        .toolbar-top {
          background-color: var(--app-header-background-color);
          max-height: 90px;
          min-height: 30px;
        }

        [main-title] {
          display: inline-block;
          font-size:-webkit-xxx-large;
          vertical-align: middle;
          padding: 0px;
        }

        .clearfix::after{
          content:"";
          clear: both;
          display: table;
        }

        .menu-btn {
          background: none;
          border: none;
          fill: var(--app-header-text-color);
          cursor: pointer;
          height: 44px;
          width: 44px;
        }

        app-drawer {
          z-index: 90000;
        }

        .drawer-list {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          padding: 24px;
          background: var(--app-drawer-background-color);
          position: relative;
        }

        .drawer-list > a {
          display: block;
          text-decoration: none;
          color: var(--app-drawer-text-color);
          line-height: 40px;
          padding: 0 24px;
        }

        .drawer-list > a[selected] {
          color: var(--app-drawer-selected-color);
        }

        /* Workaround for IE11 displaying <main> as inline */
        main {
          display: block;
        }

        .main-content {
          padding-top: 72px;
          min-height: calc(100vh - 72px);
        }

        .page {
          display: none;
        }

        .page[active] {
          display: block;
        }

        #companyLogo {
          display: inline-flex;
          font-size: xxx-large;
        }

        footer {
          padding: 6px;
          background: var(--app-drawer-background-color);
          color: var(--app-drawer-text-color);
          text-align: center;
        }

        @media print {
          app-header {
            display: none;
          }

          footer {
            display: none;
          }
        }

        /* portrait layout: when the viewport width is bigger than 500px, layout
        changes to a wide layout */
        @media (max-width: 500px) {
          #companyLogo{
            display: none;
          }
        }

        @media (max-width: 700px) {
          .year-desktop {
            display: none;
          }
        }

        @media (max-width: 700px) {
          .year-desktop {
            display: none;
          }
        }
      `
        ];
    }
    _getLoading() {
        return html `
      <div style="width: 100vw; height: 100vh; overflow:hidden; display: flex; flex-direction: column; align-items: center; justify-content: center; background-color: #ffffff;">
        <img src="images/bws_loading.gif" alt="Loading..." style="width: 350px; height: auto; transform: translateY(-20px);">
        ${this._company && this._company.get("active") === false ? html `
          <div style="margin-top: 20px; font-size: xx-large; font-weight: bold; color: var(--app-neg-text-color, #d42611); text-align: center; padding: 0 20px;">
            Your account is inactive. Please Contact Us.
          </div>
        ` : ''}
      </div>`;
    }
    render() {
        var _a;
        // Anything that's related to rendering should be done in here.
        if (!this._initialized)
            return this._getLoading();
        else if (!this._authed && this._renderLogin) {
            return html `<my-login></my-login>`;
        }
        else if (this._authed)
            return html `
    <app-header-layout>
      <!-- Header -->
      <app-header>
        <app-toolbar class="toolbar-top">
          <button class="menu-btn" title="Menu" @click=${this._menuButtonClicked}>${menuIcon}</button>
          <a class="anchor padding-top:90px" ?selected="${this._page === 'home'}" href="/home"><img src="images/manifest/bws_banner.png" type="image/png" style="max-height: 70px;"></a>
        <div>
          ${window.company && window.company.get("logo_url") ? html `<div id="companyLogo"> | 
              <img src="${window.company.get("logo_url")}" style ="max-height: 63px;">
            </div>` : ""}
        </div>
              <!-- This gets hidden on a small screen-->
              <div class="year-desktop">Year: ${(_a = window.bws_appState) === null || _a === void 0 ? void 0 : _a.year}</div>
        <div>      
        
          </div>
        </app-toolbar>
      </app-header>
      </app-header-layout>
      <!-- Drawer content -->
      <app-drawer
          .opened="${this._drawerOpened}"
          @opened-changed=${this._drawerOpenedChanged}>
        <nav class="drawer-list">
          <a ?selected="${this._page === 'home'}" href="/home">Home</a>
          ${this.hasCompanyApp("CAPTURE_LINK") ? html `<a ?selected="${this._page === 'capture'}" href="/capture">Capture Link</a>` : ''}
          ${this.hasCompanyApp("PRODUCTION") ? html `
            <a ?selected="${this._page === 'production'}" href="/production">Production</a>
            ${this._hasRole(["Admin", "Manager", "Photo Lead", "Data Lead", "Data Entry", "Customer Service", "Customer Service Lead", "Sales Manager"]) ? html `
            <a ?selected="${this._page === 'orders'}" href="/orders">Orders</a>
            <a ?selected="${this._page === 'customerservice'}" href="/customerservice">Customer Service</a>
            <a ?selected="${this._page === 'jobs'}" href="/jobs">Jobs</a>
            <a ?selected="${this._page === 'organizations'}" href="/organizations">Organizations</a>`
                : ""}
            ${this._hasRole(["Admin"]) && this.hasCompanyApp("BETA") ? html `
              <a ?selected="${this._page === 'layouts'}" href="/layouts">Layouts</a>
              ` : ''}
            ${this._hasRole(["Admin", "Accounting"]) ? html `
              <a ?selected="${this._page === 'accounting'}" href="/accounting">Accounting</a>
              ` : ''}
            ${this._hasRole(["Admin", "Sales"]) ? html `
              <a ?selected="${this._page === 'sales'}" href="/sales">Sales</a>
              ` : ''}
            ${this._hasRole(["Admin", "Photographer", "Coordinator"]) ? html `
              <a ?selected="${this._page === 'photography'}" href="/photography">My Photography</a>
              ` : ''}
            ${this._hasRole(["Admin"]) ? html `
              <a ?selected="${this._page === 'company'}" href="/company">My Company</a>
              ` : ''}
            
            `
                :
                    ''}
          ${this.hasCompanyApp("LAB") ? html `
          ${this._hasRole(["Admin", "Lab Manager", "Lab User"]) ? html `
              <a ?selected="${this._page === 'lab'}" href="/lab">Lab</a>
              ` : ''}
              ` : ''}
           ${this._vendor && this._vendor.exists() ? html `
           <a ?selected="${this._page === 'vendorjobs'}" href="/vendorjobs">Jobs</a>
           <a ?selected="${this._page === 'vendorusers'}" href="/vendorusers">Users</a>
           ` : ''}
        </nav>
      </app-drawer>
      <main role="main" class="main-content">
        ${this._page === 'home' ? html `<my-home class="page" active></my-home>` : ''}
        ${this._page === 'capture' && this.hasCompanyApp("CAPTURE_LINK") ?
                html `<my-capture class="page" active></my-capture>` : ''}
        ${this.hasCompanyApp("PRODUCTION") ? html `
          ${this._page === 'jobs' ? html `<my-jobs class="page" active></my-jobs>` : ''}
          ${this._page === 'organizations' ? html `<my-organizations class="page" active></my-organizations>` : ''}
          ${this._page === 'company' ? html `<my-company class="page" active></my-company>` : ''}
          ${this._page === 'production' ? html `<my-production class="page" active></my-production>` : ''}
          ${this._page === 'orders' ? html `<my-orders class="page" active></my-orders>` : ''}
          ${this._page === 'customerservice' ? html `<my-customerservice class="page" active></my-customerservice>` : ''}
          ${this._page === 'job' ? html `<my-job class="page" active></my-job>` : ''}
          ${this._page === 'accounting' && this._hasRole(["Admin", "Accounting"]) ? html `<my-accounting class="page" active></my-accounting>` : ''}
          ${this._page === 'sales' && this._hasRole(["Admin", "Sales"]) ? html `<my-sales class="page" active></my-sales>` : ''}
          ${this._page === 'photography' && this._hasRole(["Admin", "Photographer", "Coordinator"]) ? html `<my-photography class="page" active></my-photography>` : ''}
          ${this._page === 'layouts' && this._hasRole(["Admin"]) ? html `<my-layouts class="page" active></my-layouts>` : ''}
          `
                : ''}
        ${this._page === 'lab' && this.hasCompanyApp("LAB") && this._hasRole(["Admin", "Lab"]) ? html `
          <my-lab class="page" active></my-lab>
          ` : ''}
          
        ${this._vendor && this._vendor.exists() ? html `
          ${this._page === 'vendorjobs' ? html `<vendor-jobs class="page" active></vendor-jobs>` : ''}
          ${this._page === 'vendorsetup' && this._hasRole(["Admin"]) ? html `
            <vendor-vendor class="page" active></vendor-vendor>
          ` : ''}
        ` : ''}

        ${this._page === 'view404' ? html `<my-view404 class="page" active></my-view404>` : ''}
      </main>

      <footer>
        <p>Copyright ${(new Date()).getFullYear()} | Blue Water Suite | v${APP_VERSION}</p>
      </footer>
      <snack-bar ?active="${this._snackbarOpened}">
        You are now ${this._offline ? 'offline' : 'online'}.
      </snack-bar>
      <my-account></my-account>
    `;
        else
            return this._getLoading();
    }
    constructor() {
        super();
        this.appTitle = 'Blue Water Suite';
        this._initialized = false;
        this._renderLogin = false;
        this._authed = false;
        this._page = '';
        this._drawerOpened = false;
        this._snackbarOpened = false;
        this._offline = false;
        this._company = undefined;
        this._vendor = undefined;
        this._person = undefined;
        // To force all event listeners for gestures to be passive.
        // See https://www.polymer-project.org/3.0/docs/devguide/settings#setting-passive-touch-gestures
        setPassiveTouchGestures(true);
        //Initialize firebase
        store.dispatch(firebaseInitialize());
    }
    firstUpdated() {
        installRouter((location) => store.dispatch(navigate(decodeURIComponent(location.pathname + location.search + location.hash))));
        installOfflineWatcher((offline) => store.dispatch(updateOffline(offline)));
        installMediaQueryWatcher(`(min-width: 460px)`, () => store.dispatch(updateDrawerState(false)));
    }
    updated(changedProps) {
        if (changedProps.has('_page')) {
            const pageTitle = this.appTitle + ' | ' + this._page;
            updateMetadata({
                title: pageTitle,
                description: pageTitle
                // This object also takes an image property, that points to an img src.
            });
        }
    }
    _menuButtonClicked() {
        store.dispatch(updateDrawerState(true));
    }
    _drawerOpenedChanged(e) {
        store.dispatch(updateDrawerState(e.target.opened));
    }
    // Person doc can arrive after the company doc, so the shell renders before roles exist.
    _hasRole(roles) {
        var _a, _b;
        const personRoles = (_b = (_a = this._person) === null || _a === void 0 ? void 0 : _a.data()) === null || _b === void 0 ? void 0 : _b.roles;
        return Array.isArray(personRoles) && personRoles.some((r) => roles.indexOf(r) >= 0);
    }
    hasCompanyApp(app) {
        return this._company && this._company.exists() && Array.isArray(this._company.data().apps) && this._company.data().apps.indexOf(app) > -1;
    }
    stateChanged(state) {
        //if (!window.bws_appState){
        window.bws_appState = state.app;
        //}
        this._page = state.app.page;
        this._offline = state.app.offline;
        this._snackbarOpened = state.app.snackbarOpened;
        this._drawerOpened = state.app.drawerOpened;
        this._initialized = state.app.isInitialized;
        this._renderLogin = state.app.page === "login";
        if (this._renderLogin)
            this.requestUpdate("_renderLogin");
        let passwordNeedsReset = state.app.forcePasswordChange === true;
        const userDoc = state.app.userDoc;
        if (userDoc && userDoc.exists()) {
            if (userDoc.get("needsPasswordReset") === true || userDoc.get("passwordExpired") === true) {
                passwordNeedsReset = true;
            }
        }
        const personDoc = state.app.personDoc;
        if (personDoc && personDoc.exists()) {
            if (personDoc.get("needsPasswordReset") === true || personDoc.get("passwordExpired") === true) {
                passwordNeedsReset = true;
            }
        }
        this._authed = state.app.user && !state.app.user.isAnonymous && (state.app.companyDoc != undefined || state.app.vendorDoc != undefined) && !passwordNeedsReset;
        this.requestUpdate("_authed");
        if (!this._company && state.app.companyDoc) {
            this._company = state.app.companyDoc;
            store.dispatch(loadJobTypes());
            this.requestUpdate("_company");
        }
        this._vendor = state.app.vendorDoc;
        this._person = state.app.personDoc;
    }
};
__decorate([
    property({ type: String })
], BlueWater.prototype, "appTitle", void 0);
__decorate([
    property({ type: Boolean })
], BlueWater.prototype, "_initialized", void 0);
__decorate([
    property({ type: Boolean })
], BlueWater.prototype, "_renderLogin", void 0);
__decorate([
    property({ type: Boolean })
], BlueWater.prototype, "_authed", void 0);
__decorate([
    property({ type: String })
], BlueWater.prototype, "_page", void 0);
__decorate([
    property({ type: Boolean })
], BlueWater.prototype, "_drawerOpened", void 0);
__decorate([
    property({ type: Boolean })
], BlueWater.prototype, "_snackbarOpened", void 0);
__decorate([
    property({ type: Boolean })
], BlueWater.prototype, "_offline", void 0);
__decorate([
    property({ type: Object })
], BlueWater.prototype, "_company", void 0);
__decorate([
    property({ type: Object })
], BlueWater.prototype, "_vendor", void 0);
__decorate([
    property({ type: Object })
], BlueWater.prototype, "_person", void 0);
BlueWater = __decorate([
    customElement('blue-water')
], BlueWater);
export { BlueWater };
